import { useEffect, useState } from 'react'

const SCALE_KEY = 'compass.scale'
const SCALES = [0.9, 1, 1.15, 1.3, 1.5]

function readScale(): number {
  try {
    const v = Number(localStorage.getItem(SCALE_KEY))
    return SCALES.includes(v) ? v : 1
  } catch {
    return 1
  }
}

/** Adjustable text size (WCAG 2.1 AA, FR-C20), remembered on this device. */
export function useTextScale() {
  const [scale, setScale] = useState(readScale)
  useEffect(() => {
    document.documentElement.style.setProperty('--scale', String(scale))
    try {
      localStorage.setItem(SCALE_KEY, String(scale))
    } catch {
      // Not persisted in private mode; still applies for this visit.
    }
  }, [scale])
  const step = (d: number) => setScale((s) => SCALES[Math.min(SCALES.length - 1, Math.max(0, SCALES.indexOf(s) + d))])
  return { scale, smaller: () => step(-1), larger: () => step(1), canShrink: scale > SCALES[0], canGrow: scale < SCALES[SCALES.length - 1] }
}
